export default __webpack_public_path__ + "static/media/安检_enquire.b4b13e1c.svg";